import React, { Component } from 'react';
import Downshift from 'downshift';
import Paper from '@mui/material/Paper';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { Chip } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Spinner from '../../Utility/Spinner';
import TextInput from '../TextInput';
import { ChipBar, typeaheadSuggestion } from './MultiselectTypeAhead.styles';

class MultiselectTypeAhead extends Component {
  constructor(props) {
    super(props);
    this.state = { typeMore: false };
  }

  handleChange = selected => {
    const { values, onChange } = this.props;
    onChange([selected, ...values]);
  };

  handleSuggestionChange = suggestion => {
    const { query } = this.props;
    this.setState({ typeMore: suggestion.length < 4 });
    query(suggestion);
  };

  clearOnBlur = (stateChange, downshift) => {
    const { isOpen, setState } = downshift || {};
    const allowedTypes = [
      Downshift.stateChangeTypes.mouseUp,
      Downshift.stateChangeTypes.blurInput,
      Downshift.stateChangeTypes.clickItem
    ];

    if (stateChange && allowedTypes.includes(stateChange.type) && !isOpen) {
      this.handleSuggestionChange('');
      setState({ inputValue: '' });
    }
  };

  deleteSelected = key => {
    const { values, onChange } = this.props;

    const filtered = values.filter(({ value }) => value !== key);
    onChange(filtered);
  };

  renderChips = () => {
    const { values, theme } = this.props;

    const chipStyle = {
      backgroundColor: theme.midTheme,
      color: theme.lightText,
      margin: '5px 5px 5px 0px'
    };

    return (
      <ChipBar item xs={10}>
        {values &&
          values.map(({ label, value }) => (
            <Chip
              style={chipStyle}
              key={value}
              name={label}
              label={label}
              onDelete={() => this.deleteSelected(value)}
            />
          ))}
      </ChipBar>
    );
  };

  renderSuggestion = ({ suggestion, index, itemProps, highlightedIndex, selectedItem, inputValue }) => {
    const isHighlighted = highlightedIndex === index;
    const isSelected = selectedItem && suggestion.value === selectedItem;

    const matches = match(suggestion.label, inputValue);
    const parts = parse(suggestion.label, matches);

    return (
      <MenuItem
        {...itemProps}
        key={suggestion.value}
        selected={isHighlighted}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
          display: 'block'
        }}
      >
        {parts.map(part =>
          part.highlight ? (
            <span key={part.text} style={{ fontWeight: 600 }}>
              {part.text}
            </span>
          ) : (
            <strong key={part.text} style={{ fontWeight: 300 }}>
              {part.text}
            </strong>
          )
        )}
      </MenuItem>
    );
  };

  render() {
    const {
      loading,
      suggestions,
      error,
      errorText,
      label,
      name,
      variant,
      required,
      disabled,
      placeholder,
      values
    } = this.props;

    const { typeMore } = this.state;

    const filteredSuggestions = suggestions.filter(({ value }) => values.every(val => value !== val.value));

    return (
      <>
        <Downshift
          selected={null}
          itemToString={suggestion => (suggestion ? suggestion.label : '')}
          onChange={this.handleChange}
          onInputValueChange={this.handleSuggestionChange}
          onStateChange={this.clearOnBlur}
        >
          {({ getInputProps, getItemProps, getMenuProps, highlightedIndex, inputValue, isOpen, selectedItem }) => (
            <div style={{ position: 'relative' }}>
              <TextInput
                InputProps={{
                  ref: getInputProps().ref,
                  autoComplete: 'off'
                }}
                error={error}
                errorText={errorText}
                variant={variant}
                label={label}
                name={name}
                required={required}
                disabled={disabled}
                placeholder={placeholder}
                {...getInputProps({
                  onBlur: () => {
                    this.clearOnBlur();
                  }
                })}
                value={inputValue}
              />
              <div {...getMenuProps()}>
                {isOpen ? (
                  <Paper square style={{ position: 'absolute', zIndex: typeaheadSuggestion, width: '100%' }}>
                    {typeMore ? (
                      <MenuItem disabled>
                        <span>Type more for results</span>
                      </MenuItem>
                    ) : (
                      <>
                        {loading && (
                          <MenuItem style={{ display: 'flex', justifyContent: 'space-around' }}>
                            <Spinner thickness={4} size={25} />
                          </MenuItem>
                        )}
                        {!loading && filteredSuggestions.length === 0 && (
                          <MenuItem disabled>
                            <span>No Results</span>
                          </MenuItem>
                        )}
                        {!loading &&
                          filteredSuggestions.slice(0, 5).map((suggestion, index) =>
                            this.renderSuggestion({
                              suggestion,
                              index,
                              itemProps: getItemProps({ item: suggestion }),
                              highlightedIndex,
                              selectedItem,
                              inputValue
                            })
                          )}
                      </>
                    )}
                  </Paper>
                ) : null}
              </div>
            </div>
          )}
        </Downshift>
        {this.renderChips()}
      </>
    );
  }
}

export default MultiselectTypeAhead;
